import { ArrowLeftOutlined, DeleteOutlined, LinkOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { BaseButton } from '../../../components/UI/BaseButton';
import { ExpandDown } from '../../../assets/CustomIcons/ExpandDown';
import Icon from '@ant-design/icons';

export interface TaskHeaderProps {
  onBack: () => void;
  onPreviousTask: () => void;
  onNextTask: () => void;
  onCopyLink: () => void;
  onDelete: () => void;
  showBackButton: boolean;
  previousTaskId: number | null;
  nextTaskId: number | null;
  centerSlot?: React.ReactNode;
}

export const TaskHeader: React.FC<TaskHeaderProps> = React.memo(
  ({ onBack, onPreviousTask, onNextTask, onCopyLink, onDelete, previousTaskId, nextTaskId, showBackButton, centerSlot }) => (
    <div className="relative flex items-center justify-between z-40 px-10 py-[18px] sticky top-0 bg-brand-white">
      <div className="w-[67px]">
        {showBackButton && (
          <BaseButton type="secondary" size="small" onClick={onBack}>
            <ArrowLeftOutlined />
            Back
          </BaseButton>
        )}
      </div>
      {centerSlot && (
        <div className="absolute left-1/2 -translate-x-1/2 pointer-events-none">
          <div className="pointer-events-auto">{centerSlot}</div>
        </div>
      )}
      <div className="flex gap-2">
        <Button
          className="text-neutral-900"
          icon={<Icon component={ExpandDown} style={{ transform: 'rotate(180deg)' }} />}
          size="small"
          disabled={!previousTaskId}
          onClick={onPreviousTask}
        />
        <Button
          className="text-neutral-900"
          icon={<Icon component={ExpandDown} />}
          size="small"
          disabled={!nextTaskId}
          onClick={onNextTask}
        />
        <Button className="text-neutral-900" icon={<LinkOutlined />} size="small" onClick={onCopyLink} />
        <Button className="text-neutral-900" icon={<DeleteOutlined />} size="small" onClick={onDelete} />
      </div>
    </div>
  )
);
